import { Dialog } from '@datacamp/waffles-modals';
import React from 'react';
import { useTranslation } from '../useTranslation';
import { jsx as ___EmotionJSX } from "@emotion/react";
const CompletionPaneShortcutsModal = _ref => {
  let {
    hideShortcutModal,
    isOpen
  } = _ref;
  const {
    t
  } = useTranslation();
  const shortcuts = [{
    keys: ['Ctrl', 'Shift', 'Enter'],
    label: t('CompletionPaneShortcutsModal.submitAnswer')
  }, {
    keys: ['Ctrl', 'Enter'],
    label: t('CompletionPaneShortcutsModal.execute')
  }, {
    keys: ['Enter'],
    label: t('CompletionPaneShortcutsModal.submitMultipleChoice')
  }, {
    keys: ['Ctrl', 'H'],
    label: t('CompletionPaneShortcutsModal.getHint')
  }];
  return ___EmotionJSX(Dialog, {
    isOpen: isOpen,
    onClose: hideShortcutModal,
    width: 660
  }, ___EmotionJSX(Dialog.Header, null, t('CompletionPaneShortcutsModal.header')), ___EmotionJSX(Dialog.Body, null, ___EmotionJSX("div", {
    className: "dc-table-wrapper dc-table-wrapper--bordered"
  }, ___EmotionJSX("table", {
    className: "dc-table dc-table--bordered"
  }, ___EmotionJSX("tbody", {
    className: "dc-table__tbody"
  }, shortcuts.map(_ref2 => {
    let {
      keys,
      label
    } = _ref2;
    return ___EmotionJSX("tr", {
      className: "dc-table__tr",
      key: label
    }, ___EmotionJSX("td", {
      className: "dc-table__td"
    }, label), ___EmotionJSX("td", {
      className: "dc-table__td"
    }, ___EmotionJSX("div", {
      className: "dc-u-tt-uppercase"
    }, keys.reduce(
    // @ts-expect-error ts-migrate(2769) FIXME: Type 'Element' is not assignable to type 'never'.
    (acc, key) => [...acc, ...[___EmotionJSX("span", {
      className: "dc-u-mh-8",
      key: "".concat(key, "-separator")
    }, "+"), ___EmotionJSX("span", {
      className: "dc-completion-pane__key",
      key: "".concat(key, "-value")
    }, key)]], []).slice(1))));
  }))))));
};
export default CompletionPaneShortcutsModal;